export default __webpack_public_path__ + "static/media/delivery.8abd5eb5.svg";